import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../colecciones.css";

const colecciones = [
  {
    name: "Rodilleras",
    description: "Soporte y estabilidad para cargas máximas",
    image: "../Colleciones/rodis-sbd-power-coll.jpg",
    link: "/rodilleras",
  },
  {
    name: "Rodilleras Rígidas",
    description: "Soporte y estabilidad para cargas máximas",
    image: "../Colleciones/inzer-coll-2.jpg",
    link: "/rodilleras-rig",
  },
  {
    name: "Cinturones",
    description: "Seguridad y transferencia de fuerza",
    image: "../Banners/sbd-belt-banner.jpg",
    link: "/cinturones",
  },
  {
    name: "Calzado",
    description: "Estabilidad y potencia desde el suelo",
    image: "../Colleciones/ava-coll-2.jpg",
    link: "/calzado",
  },
  {
    name: "Muñequeras",
    description: "Firmeza y control en cada repetición",
    image: "../Colleciones/muñ-sbd-coll.jpg",
    link: "/muñequeras",
  },
    {
    name: "Singlets",
    description: "Firmeza y control en cada repetición",
    image: "../Colleciones/sing-coll.jpg",
    link: "/singlets",
  },   
  {
    name: "Vendas",
    description: "Firmeza y control en cada repetición",
    image: "../Productos/vendas-sbd.webp",
    link: "/vendas",
  },
];

const Colecciones = () => {
  return (
    <>
      <Navbar />

      <div className="colecciones-wrapper">

        <div className="colecciones-hero">
          <h2>COLECCIONES</h2>
          <p>Explorá nuestras líneas de equipamiento profesional</p>
        </div>

        <div className="colecciones-grid">
          {colecciones.map((c) => (
            <Link to={c.link} key={c.name} className="coleccion-card">
              <div
                className="coleccion-image"
                style={{ backgroundImage: `url(${c.image})` }}
              >
                <div className="coleccion-overlay">
                  <h3 style={{textTransform: "uppercase"}}>{c.name}</h3>

                  <span className="coleccion-btn">
                    Explorar
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

      </div>

      <Footer />
    </>
  );
};

export default Colecciones;
